import {
  GetHeapTrackerSharedScanCountOptions,
  getHeapTrackerSharedScanCount
} from '../utils/getHeapTrackerSharedScanCount'
import { useAPI } from '@dtx-company/inter-app/src/hooks/useAPI'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useState } from 'react'

export function useHeapTrackerSharedScanCount(): number | undefined {
  const authState = useAuthState()

  // Get an initial date - keep it persistent to avoid unnecessary calls
  // and keep heap properties consistent
  // Ideally would be nice to change it between "sessions" if there's
  // a decent way to define that but changing between app reloads
  // is probably sufficient, doesn't need to be super accurate but
  // just generally allow filtering to separate active vs inactive users
  const [nowDate] = useState(() => new Date())

  const sharedScanCountSWR = useAPI<GetHeapTrackerSharedScanCountOptions, number | null, Error>(
    'useHeapTrackerSharedScanCountSWR',
    getHeapTrackerSharedScanCount,
    () => {
      if (!authState.isAuthChecked) return
      if (!authState.token) return
      return {
        token: authState.token,
        nowDate: nowDate
      }
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnMount: true
    }
  )

  return sharedScanCountSWR.data ?? undefined
}
